<template>
  <div class="item">

    <img class="logo" src="../../../../static/img/logo-lianzhen.png"/>




    <div class="province-block">
      <div class="line">
        <div>已签约网点 &nbsp;&nbsp;&nbsp; {{totalNum}} 个</div>
      </div>

      <a-list :grid="{ gutter: 16, column: 4 }" :data-source="provinceData" split>
        <a-list-item slot="renderItem" slot-scope="item, index">
          <div class="province-item clickable" @click="clickProvince(item.province)">
            <div class="province-name" >{{item.province.substr(0,2)}}</div>
            <div class="province-num" >{{item.num}}个</div>
          </div>

        </a-list-item>
      </a-list>



<!--      <div class="line clickable" v-for="item in provinceData" @click="clickProvince(item.province)">-->
<!--        <div class="province-name">{{item.province}}</div>-->
<!--        <div class="province-num">{{item.num}} 个</div>-->
<!--      </div>-->
    </div>

    <div class="marquee_box">
      <div class="marquee_list" :class="{marquee_top:animate}">
        <div class="repair-point-info" v-for="(item,index) in list">{{item.signYear}}年{{item.signMonth}}月 {{item.name}} 加入了联真签约维修服务网点</div>
      </div>
    </div>

  </div>

</template>

<script>
  export default {
    props: ['list','provinceData'],
    mounted () {
      setInterval(this.showMarquee, 2000);
    },
    computed:{
      totalNum(){
        var num=0
        this.provinceData.forEach(item=>{
          num+=parseInt(item.num)
        })
        return num
      }
    },
    methods:{
      clickProvince(province){
        this.$emit("clickProvince",province)
      },
      showMarquee: function() {
        this.animate = true;

        setTimeout(() => {
          this.list.push(this.list[0]);
          this.list.shift();
          this.animate = false;
        }, 500);
      }
    },
    data(){
      return {
        animate: false,
      }
    }
  }
</script>

<style scoped>

  .item{
    height: 99%;
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  .province-block {
    overflow-y: hidden;
    border: 0.5px solid #00F6FF;
    box-shadow: 0 0 20px rgba(10, 76, 139, 1);
    padding: 0 20px;
    position: relative;
    width:600px;
  }

  .line {
    display: flex;
    padding: 15px 30px;
    border-bottom: 1px solid rgba(0,0,0,0.4);
    color: rgba(255,255,255,0.8);
    font-size: 20px;
  }

  .province-item{
    display: flex;
    padding: 10px;
    background: rgba(200,200,200,0.1);
    border-radius: 3px;
  }

  .province-name{
    width: 60px;
    font-size: 18px;
    color:#fff;
  }

  .province-num{
    font-size: 18px;
    color:#fff;
  }


  .logo{
    height: 30px;
    margin:30px 0;
  }

  .clickable{
    cursor: pointer;
  }

  .clickable:hover{
    background: rgba(255,255,255,0.2);
  }



  .marquee_box {
    display: block;
    position: relative;
    margin-top: 30px;
    overflow: hidden;
    padding: 30px;
    background-image: url("../../../../static/img/bg-repair-point-list.png");
    width:700px;
    height:200px;
    background-repeat:no-repeat;
    background-size:100% 100%;
  }

  .marquee_list {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }

  .marquee_top {
    transition: all 0.5s;
    margin-top: -60px;
  }

  .repair-point-info{
    font-size: 20px;
    height: 60px;
    line-height: 90px;
    color: #fff;
    margin-left: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/views/home/board/RepairPointList.vue